import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-lista-de-fornecedores-view.component',
  templateUrl: './lista-de-fornecedores-view.component.html',
  styleUrls: ['./lista-de-fornecedores-view.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class ListadeFornecedoresViewComponent implements OnInit {
  pessoaId = -1;

  constructor(private router: Router, private route: ActivatedRoute) {}

  async ngOnInit() {
    this.pessoaId = Number(this.route.snapshot.paramMap.get('id'));

    if (!this.pessoaId || this.pessoaId <= 0) {
      this.router.navigate(['/lista-de-fornecedores']);
      return;
    }
  }
}
